/* Figma: 2161:7140 — 1228x57, pl 53 pr 12 py 12, bottom border #e3e3e3 */
.bar {
  display: flex;
  align-items: center;
  height: var(--chipbar-h);
  padding: 12px 12px 12px 53px;
  background: var(--bg-page);
  border-bottom: 1px solid var(--border-chipbar);
}

.inner { display: flex; align-items: center; gap: 20px; }

.legend {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  white-space: nowrap;
}

.chips { display: flex; align-items: center; gap: 12px; }

/* Badge — 2161:7163 */
.chip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px;
  overflow: hidden;
  background: var(--bg-chip);
  box-shadow: inset 0 0 0 1px var(--border-chip);
  border-radius: var(--radius-chip);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #000;
  white-space: nowrap;
}

.chipIconCategory { width: 16px; height: 12.322px; flex-shrink: 0; }
.chipIconCity { width: 13px; height: 16px; flex-shrink: 0; }
.chipIconSku { width: 20px; height: 20px; flex-shrink: 0; }
